// -----------------------------
// URL helpers
// -----------------------------

export function safeParseUrl(url: string, baseOrigin?: string): URL | null {
  try {
    const base =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : baseOrigin || 'http://localhost';
    return new URL(url, base);
  } catch {
    return null;
  }
}

export function pathSegments(url: string, baseOrigin?: string): string[] {
  const u = safeParseUrl(url, baseOrigin);
  if (!u) return [];
  return u.pathname.split('/').filter(Boolean);
}

export function hashString(str: string): string {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return `ctx_${Math.abs(h)}`;
}
